// UpdateSubscription.jsx
import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { peoplePlansQA, peoplePlansProduction } from '../AddSubscription/plans'
import useSubscriptionStore from '../SubscriptionStore'
import CircularProgress from '@material-ui/core/CircularProgress'
import { getAccount } from '../../../../Api/index'
import { useQuery } from 'react-query'
import useEscapeKey from '../../../utils/useEscapeKey'

export default function UpdateSubscription ({
  onContinue,
  isLoading,
  handleCloseOnClick
}) {
  const { data: account } = useQuery('account', getAccount)
  const [isVisible, setIsVisible] = useState(false)
  const [isYearly, setIsYearly] = useState(false)
  const { selectedPlan, setSelectedPlan, isModalHidden } =
    useSubscriptionStore()
  const [isLoadingInternality, setIsLoadingInternality] = useState(false)

  const planOrder = isYearly
    ? [
        'people-100-annual',
        'people-1k-annual',
        'people-5k-annual',
        'people-10k-annual'
      ]
    : [
        'people-100-trial',
        'people-100-19',
        'people-1k-99',
        'people-5k-449',
        'people-10k-799'
      ]
  // Determine current plan index and the user's current plan ID (lowercased)
  const currentPlanId = account?.data?.plans
    ?.find(p => p.dataType === 'people')
    ?.id?.toLowerCase()
  const currentIndex = planOrder.indexOf(currentPlanId)

  // Pre‑select current plan
  useEffect(() => {
    if (currentPlanId) {
      setSelectedPlan(currentPlanId)
    }
  }, [currentPlanId, setSelectedPlan])

  // Slide in
  useEffect(() => {
    const t = setTimeout(() => setIsVisible(true), 1)
    return () => clearTimeout(t)
  }, [])

  const handleClose = e => {
    e.stopPropagation()
    setIsVisible(false)
    setTimeout(() => handleCloseOnClick && handleCloseOnClick(), 250)
  }

  useEscapeKey(e => handleClose(e))

  const handleContinue = e => {
    e.stopPropagation()
    // If no plan is selected or if it is the same as the current plan, just return
    if (!selectedPlan || selectedPlan.toLowerCase() === currentPlanId) {
      return
    }
    //     setIsVisible(false)
    //     setTimeout(() => onContinue && onContinue(), 250)
    if (selectedPlan) {
      if (onContinue) onContinue()
      setIsLoadingInternality(true)
    }
  }

  useEffect(() => {
    if (isModalHidden) setIsVisible(false)
  }, [isModalHidden])

  const isQA =
    window.location.hostname.includes('qa') ||
    window.location.hostname === 'localhost'
  const peoplePlans = isQA ? peoplePlansQA : peoplePlansProduction

  const filteredPlans = (
    isYearly
      ? peoplePlans
          .filter(p => p.yearlyPrice !== 'Free')
          .map(p => ({ ...p, id: p.yearlyId, price: p.yearlyPrice }))
      : peoplePlans
  ).filter(p => !p.name.toLowerCase().includes('unlimited'))

  const getBoxStyle = planId =>
    planId === selectedPlan ? styles.SelectedBoxProperty : styles.BoxProperty

  return (
    <div className={styles.modalBackdrop} onClick={handleClose}>
      <div
        className={styles.modalContent}
        style={{
          transform: isVisible ? 'translateX(0)' : 'translateX(100%)'
        }}
        onClick={e => e.stopPropagation()}
      >
        <h1 className={styles.titleH1Subscription}>
          Upgrade people data subscription
        </h1>
        <p className={styles.PSubscription}>
          You don't have sufficient people data credits left to view this
          record. Upgrade your subscription to see it. Choose the subscription
          tier you want from the options below.
        </p>

        <div className={styles.FirstContainerAddSubscription}>
          <h2 className={styles.H2PeopleDataSubscription}>
            People data subscription
          </h2>
          <div className={styles.PricingToggle}>
            <span
              className={!isYearly ? styles.Active : styles.Inactive}
              onClick={() => setIsYearly(false)}
            >
              Monthly
            </span>
            <span
              className={isYearly ? styles.Active : styles.Inactive}
              onClick={() => setIsYearly(true)}
            >
              Annual
            </span>
          </div>
        </div>

        <div className={styles.plansContainer}>
          {filteredPlans.map(plan => {
            const thisIndex = planOrder.indexOf(plan.id)
            const disabled = thisIndex < currentIndex
            return (
              <div
                key={plan.id}
                className={getBoxStyle(plan.id)}
                onClick={() => {
                  if (!disabled) setSelectedPlan(plan.id)
                }}
                style={{
                  cursor: disabled ? 'not-allowed' : undefined,
                  pointerEvents: disabled ? 'none' : 'auto',
                  borderColor: disabled ? '#E5E5E5' : undefined
                }}
              >
                <div className={styles.BoxPropertyDirection}>
                  <span
                    style={{ color: disabled ? '#E5E5E5' : undefined }}
                    className={
                      plan.id === selectedPlan
                        ? styles.SelectedSpanTitleBoxProperty
                        : styles.SpanTitleBoxProperty
                    }
                  >
                    {plan.name}
                    {plan.id.toLowerCase() === currentPlanId && (
                      <span className={styles.CurrentTierLabel}>
                        {' '}
                        (Current tier)
                      </span>
                    )}
                  </span>
                  <span
                    style={{ color: disabled ? '#E5E5E5' : undefined }}
                    className={
                      plan.id === selectedPlan
                        ? styles.SelectSpanBoxProperty
                        : styles.SpanBoxProperty
                    }
                  >
                    {plan.records}
                  </span>
                </div>
                <div className={styles.BoxPropertySpacing}>
                  <div>
                    <span
                      style={{
                        display: 'block',
                        color: disabled ? '#E5E5E5' : undefined
                      }}
                      className={
                        plan.id === selectedPlan
                          ? styles.SelectSpanBoxProperty
                          : styles.SpanBoxProperty
                      }
                    >
                      {plan.price}
                    </span>
                    <span
                      style={{ color: disabled ? '#E5E5E5' : undefined }}
                      className={
                        plan.id === selectedPlan
                          ? styles.SelectSpanBoxProperty
                          : styles.SpanBoxProperty
                      }
                    >
                      per {isYearly ? 'year' : 'month'}
                    </span>
                  </div>
                  <div>
                    <span
                      style={{ color: disabled ? '#E5E5E5' : undefined }}
                      className={
                        plan.id === selectedPlan
                          ? styles.SelectSpanBoxProperty
                          : styles.SpanBoxProperty
                      }
                    >
                      {plan.id === selectedPlan ? 'Selected' : 'Select'}
                    </span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <button
          disabled={
            !selectedPlan ||
            isLoading ||
            isLoadingInternality ||
            selectedPlan?.toLowerCase() === currentPlanId
          }
          className={styles.buttonSettingsUpdate}
          onClick={handleContinue}
        >
          {isLoading || isLoadingInternality ? (
            <CircularProgress size={20} style={{ color: 'white' }} />
          ) : (
            'Continue'
          )}
        </button>
      </div>
    </div>
  )
}
